import { FooterNavItem } from '@/components/nav/footer';
import { Flex } from '@mantine/core';
import {
	IconHomeBolt,
	IconLayoutGridAdd,
	IconLogout,
	IconRestore,
	IconSettings,
	IconShoppingCart,
	IconTrophy,
} from '@tabler/icons-react';
import { ComponentProps } from 'react';
import styles from './styles.module.css';

export type BottomNavProps = {
	nav: 'home' | 'facility';
};

const navSets: Record<BottomNavProps['nav'], ComponentProps<typeof FooterNavItem>[]> = {
	home: [
		{ to: '/home', label: 'Home', icon: IconHomeBolt },
		{ to: '/scan', label: 'Scan', icon: IconLayoutGridAdd },
		{
			to: '/rewards',
			label: 'Rewards',
			icon: IconTrophy,
			additionalActivePaths: ['/past-winners'],
		},
		{ to: '/shop', label: 'Order', icon: IconShoppingCart },
	],
	facility: [
		{ to: '/facility/home', label: 'Home', icon: IconHomeBolt },
		{ to: '/facility/history', label: 'History', icon: IconRestore },
		{ to: '/auth/logout', label: 'Log Out', icon: IconLogout },
		{ to: '/facility/settings', label: 'Settings', icon: IconSettings },
	],
};

export const BottomNav = ({ nav }: BottomNavProps) => {
	const navItems = navSets[nav];

	return (
		<Flex w="100%" className={styles.root} gap="lg" align="center" justify="space-around">
			{navItems.map((item) => (
				<FooterNavItem key={item.to} {...item} />
			))}
		</Flex>
	);
};
